import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useFarbwelt, useScrollEffect } from "@/hooks";
import { Box } from "@gemini/core";
import { useRef } from "react";
import { FarbweltTeaser } from "./FarbweltTeaser";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
export const FarbweltDesktopTeasers = ({ initialTopOffset = 150, }) => {
    const { teasers } = useFarbwelt();
    const isPreviewMode = useIsPreviewMode();
    const mediumRectangleTop = Array.isArray(teasers) && // temporary fix while we wait for bff to return an array
        (teasers === null || teasers === void 0 ? void 0 : teasers.find((teaser) => teaser.type === "MediumRectangleTop"));
    const mediumRectangleBottom = Array.isArray(teasers) && // temporary fix while we wait for bff to return an array
        (teasers === null || teasers === void 0 ? void 0 : teasers.find((teaser) => teaser.type === "MediumRectangleBottom"));
    const adRectangle1 = useRef(null);
    const adRectangle2 = useRef(null);
    const containerRef = useRef(null);
    const { pinnedAd1, ad1Top } = useScrollEffect(
    // @ts-ignore
    adRectangle1, adRectangle2, containerRef);
    if (isPreviewMode) {
        return null;
    }
    return (_jsx(Box, { display: "flex", flex: "1", minHeight: "0", alignItems: "center", flexDirection: "column", ref: containerRef, unsafe_className: "HideOnPrint", children: teasers && (_jsxs(_Fragment, { children: [_jsx(Box, { position: pinnedAd1 ? "relative" : "sticky", top: pinnedAd1 ? ad1Top : initialTopOffset, ref: adRectangle1, display: "flex", children: _jsx(FarbweltTeaser
                    // @ts-ignore
                    , { 
                        // @ts-ignore
                        teaser: mediumRectangleTop, av_zone: "side" }) }), _jsx(Box, { minHeight: "25%", width: "100%" }), _jsx(Box, { ref: adRectangle2, display: "flex", position: "sticky", top: initialTopOffset, children: _jsx(FarbweltTeaser
                    // @ts-ignore
                    , { 
                        // @ts-ignore
                        teaser: mediumRectangleBottom, av_zone: "side" }) })] })) }));
};
